import { DataObject } from '../interfaces/myAssetInterface';

export function convertTo2DArray(data: any[], orderedHeaders?: string[]): (string | number)[][] {
	if (data.length === 0) {
		return [];
	}
	if (orderedHeaders) {
		return [orderedHeaders, ...data.map((item) => orderedHeaders.map((header) => item[header] ?? ''))];
	}
	// Coleta todas as chaves únicas de todos os objetos
	const headersSet = new Set<string>();
	for (const item of data) {
		for (const key of Object.keys(item)) headersSet.add(key);
	}
	const headers = [...headersSet];

	const resultArray: (string | number)[][] = [headers];
	for (const item of data) {
		const row = headers.map((header) => item[header] ?? '');
		resultArray.push(row);
	}

	return resultArray;
}
